module.exports = __webpack_public_path__ + "static/media/You’ll Receive.1c3fe3a8.svg";